/* The Waste stock tab: four tiles, waste produced day by day stacked by
 * stream, and the waste register's month by type. */

import { Blueprint, KpiRow, PanelHead } from '../../components/ui'
import { Frame, PANEL, RIGHT, ShareBar, Swatch, Tip } from './parts'
import type { Built } from './model'

export function WasteTab({ v, setHov }: { v: Built; setHov: (d: string | null) => void }) {
  return (
    <>
      <KpiRow items={v.wKpis} />

      <Blueprint className="sheet" style={PANEL}>
        <PanelHead title="Waste produced, day by day" hint="Stacked by waste type · hover a day" />
        <Frame height={220} ticks={v.wTicks} labels={v.dayLabels} labelGap={3} onLeave={() => setHov(null)}>
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end', gap: 3, padding: '0 4px' }}>
            {v.wCols.map((c) => (
              <div key={c.d} onMouseEnter={() => setHov(c.d)} style={{
                flex: '1 1 0', minWidth: 0, height: '100%', display: 'flex', flexDirection: 'column-reverse', opacity: c.op,
              }}>
                {c.segs.map((s, i) => (
                  <div key={i} style={{ height: s.h, background: s.bg, boxShadow: 'inset 0 1px 0 var(--color-bg)' }} />
                ))}
              </div>
            ))}
          </div>
          {v.wHov ? (
            <Tip left={v.wHov.left} shift={v.wHov.shift} minWidth={200}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontWeight: 600, marginBottom: 6 }}>
                <span>{v.wHov.title}</span><span className="num">{v.wHov.total}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {v.wHov.rows.map((r) => (
                  <div key={r.label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ width: 10, height: 10, display: 'block', flex: 'none', background: r.bg }} />
                    <span style={{ flex: 1, color: 'var(--color-neutral-700)' }}>{r.label}</span>
                    <span className="num" style={{ fontWeight: 600 }}>{r.v}</span>
                  </div>
                ))}
              </div>
            </Tip>
          ) : null}
        </Frame>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 14 }}>
          {v.wLegend.map((l) => (
            <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: 'var(--color-neutral-800)' }}>
              <span style={{ width: 12, height: 12, display: 'block', background: l.bg }} />{l.label}
            </div>
          ))}
        </div>
      </Blueprint>

      <Blueprint className="sheet" style={PANEL}>
        <h2 style={{ fontSize: 22, margin: 0 }}>Waste stock by type</h2>
        <div style={{ overflowX: 'auto', marginTop: 14 }}>
          <table className="table num" style={{ minWidth: 720 }}>
            <thead>
              <tr>
                <th>Waste type</th>
                <th style={RIGHT}>Opening</th>
                <th style={RIGHT}>Produced</th>
                <th style={RIGHT}>Reused</th>
                <th style={RIGHT}>Sold / disposed</th>
                <th style={RIGHT}>Closing</th>
                <th style={{ width: '20%' }}>Share of produced</th>
              </tr>
            </thead>
            <tbody>
              {v.wRows.map((r) => (
                <tr key={r.label}>
                  <td style={{ whiteSpace: 'nowrap', fontWeight: 600 }}><Swatch bg={r.bg} />{r.label}</td>
                  <td style={RIGHT}>{r.open}</td>
                  <td style={RIGHT}>{r.prod}</td>
                  <td style={RIGHT}>{r.reuse}</td>
                  <td style={RIGHT}>{r.sold}</td>
                  <td style={{ ...RIGHT, fontWeight: 600 }}>{r.close}</td>
                  <td><ShareBar w={r.w} bg={r.bg} share={r.share} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pretty" style={{ fontSize: 12, color: 'var(--color-neutral-700)', marginTop: 12, lineHeight: 1.5, maxWidth: '100ch' }}>
          {v.wNote}
        </div>
      </Blueprint>
    </>
  )
}
